export default "__VITE_ASSET__BHb$R8yu__"